var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-holder"},[_c('img',{attrs:{"src":require("@/assets/logo.svg")}}),_c('div',{staticClass:"eye-top"}),_c('div',{staticClass:"eye-bottom"})])
}]

export { render, staticRenderFns }